import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

interface AssignVars {
	groupId: number;
	userIds: string[];
}

const assignGroupMembers = async ({ groupId, userIds }: AssignVars) => {
	await cmsClient.post<unknown>(`/users/groups/${groupId}/members/`, {
		user_ids: userIds
	});
};

const useAssignGroupMembers = () => {
	const queryClient = useQueryClient();

	const onSuccess = (_: unknown, variables: AssignVars) => {
		const count = variables.userIds.length;
		toast.success(
			<CustomToast
				type="Success"
				message={`${count} ${count === 1 ? "member" : "members"} added`}
			/>,
			{ hideProgressBar: true }
		);
	};

	const onSettled = (_: unknown, __: unknown, variables: AssignVars) => {
		queryClient.invalidateQueries(["group-members"]);
		queryClient.invalidateQueries(["group-member-ids", variables.groupId]);
		queryClient.invalidateQueries(["admin-groups"]);
		queryClient.invalidateQueries(["admin-groups-paged"]);
		queryClient.invalidateQueries(["admin-group", variables.groupId]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	return useMutation(assignGroupMembers, {
		onError,
		onSuccess,
		onSettled
	});
};

export default useAssignGroupMembers;
